import { useCallback } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

export function useSelectedSlotRoute() {
	const location = useLocation();
	const navigate = useNavigate();
	const { slotId } = useParams<{ slotId?: string }>();
	const selectedSlotId = slotId ?? null;

	const setSelectedSlotId = useCallback((nextSlotId: string | null) => {
		const pathname = nextSlotId ? `/admin/terminy/${nextSlotId}` : '/admin/terminy';
		navigate(
			{
				pathname,
				search: location.search,
			},
			{ replace: true }
		);
	}, [location.search, navigate]);

	const toggleSelectedSlotId = useCallback((nextSlotId: string | null) => {
		if (nextSlotId === selectedSlotId) {
			setSelectedSlotId(null);
			return;
		}
		setSelectedSlotId(nextSlotId);
	}, [selectedSlotId, setSelectedSlotId]);

	return {
		selectedSlotId,
		setSelectedSlotId,
		toggleSelectedSlotId,
	};
}